import axios from 'axios';

const API_BASE = '/api/v1/roles';

export const listRoles = async () => {
  const response = await axios.get(API_BASE, { withCredentials: true });
  return response.data;
};

export const createRole = async (data: any) => {
  const response = await axios.post(API_BASE, data, { withCredentials: true });
  return response.data;
};

export const updateRole = async (id: string, data: any) => {
  const response = await axios.put(`${API_BASE}/${id}`, data, { withCredentials: true });
  return response.data;
};

export const deleteRole = async (id: string) => {
  const response = await axios.delete(`${API_BASE}/${id}`, { withCredentials: true });
  return response.data;
};
